// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-to-cart-button-in-item-list .soldout[data-v-4d7aa35f]{display:block;font-size:1.5rem;text-align:center}", ""]);
// Exports
module.exports = exports;
